// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"5cfbd5ab","544":"30a38c2f"}[chunkId] + ".chunk.css";
};